import { render } from "./WebcamLiveFeed.vue?vue&type=template&id=6e7db3d0&scoped=true&ts=true"
import script from "./WebcamLiveFeed.vue?vue&type=script&lang=ts"
export * from "./WebcamLiveFeed.vue?vue&type=script&lang=ts"

import "./WebcamLiveFeed.vue?vue&type=style&index=0&id=6e7db3d0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-speech/democratielab-speech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7db3d0"]])

export default __exports__